import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  SET_LOGIN_LEVELS,
} from "../actions/auth";
import { USER_REQUEST, USER_SET_LEVEL } from "../actions/user";
import axios from "axios";
import { clearCacheOnly } from "@/utils/CacheManager";

const state = {
  token: localStorage.getItem("DR_P-user-token") || "",
  IdUser: localStorage.getItem("DR_P-user-id") || "",
  status: "",
  livelliLogin: [],
  hasLoadedOnce: false,
};

const getters = {
  isAuthenticated: (state) => !!state.token,
  authStatus: (state) => state.status,
  getLivelliLogin: (state) => state.livelliLogin,
};

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      axios
        .post("Auth", user)
        .then((resp) => {
          console.log('AUTH response:', resp.data);
          if (resp.data.Success) {
            commit(SET_LOGIN_LEVELS, resp.data.livelli);
            localStorage.setItem("DR_P-user-token", resp.data.Token);
            localStorage.setItem("DR_P-user-id", resp.data.IdUser);
            axios.defaults.headers.common["Authorization"] = resp.data.Token;
            commit(AUTH_SUCCESS, resp);
            dispatch(USER_REQUEST, resp.data.IdUser);
            
            // El composable useSessionTimeout tiene un watch que detectará este cambio
            console.log('✅ AUTH_SUCCESS committed - El watch del composable debería detectarlo');
            
            // Verificar versión después de login exitoso
            if (resp.data.frontVersion !== undefined && resp.data.frontVersion !== null) {
              const currentVersionRaw = typeof __APP_VERSION__ !== 'undefined' ? String(__APP_VERSION__) : '0.0.0';
              const serverVersionRaw = String(resp.data.frontVersion);

              // Normalizar a la parte "major" (antes del primer punto) para compatibilidad
              const normalizeMajor = (v) => {
                const parts = String(v).split('.');
                return parts.length ? parts[0] : String(v);
              };

              const currentMajor = normalizeMajor(currentVersionRaw);
              const serverMajor = normalizeMajor(serverVersionRaw);

              if (currentMajor !== serverMajor) {
                console.log(`Nueva versión disponible. Actual: ${currentVersionRaw}, Servidor: ${serverVersionRaw}`);
                // Ejecutar reload después de un pequeño delay para permitir que el login termine
                setTimeout(() => {
                  // Limpiar caches del navegador
                  if ('caches' in window) {
                    caches.keys().then(names => {
                      names.forEach(name => caches.delete(name));
                    });
                  }
                  // Forzar recarga completa
                  window.location.reload(true);
                }, 500);
              }
            }
          } else {
            commit(AUTH_ERROR);
            localStorage.removeItem("DR_P-user-token");
            localStorage.removeItem("DR_P-user-id");
          }
          resolve(resp);
        })
        .catch((err) => {
          commit(AUTH_ERROR, err);
          localStorage.removeItem("DR_P-user-token");
          localStorage.removeItem("DR_P-user-id");
          reject(err);
        });
    });
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(async (resolve) => {
      // Limpiar cache antes de hacer logout
      try {
        await clearCacheOnly();
      } catch (error) {
        console.error('Error al limpiar cache en logout:', error);
      }
      
      commit(AUTH_LOGOUT);
      localStorage.removeItem("DR_P-user-token");
      localStorage.removeItem("DR_P-livelloLogin");
      localStorage.removeItem("DR_P-user-id");
      delete axios.defaults.headers.common["Authorization"];
      resolve();
    });
  },
};

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = "loading";
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = "success";
    state.token = resp.data.Token;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state) => {
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = "";
    state.IdUser = null;
    state.livelliLogin.splice(0);
    state.status = "";
  },
  [SET_LOGIN_LEVELS]: (state, payload) => {
    state.livelliLogin = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
